const IO_TRANSPORTS = {
  WEBSOCKET: 'websocket',
  POLLING: 'polling',
};

Object.freeze(IO_TRANSPORTS);

export default IO_TRANSPORTS;
